import React, { useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import SEO from "./components/SEO";


import { shouldRedirectToDomain } from "./utils/domainRouter";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Tours from "./pages/Tours";
import VehicleRental from "./pages/VehicleRental";
import Accommodation from "./pages/Accommodation";
import TraditionalMedicine from "./pages/TraditionalMedicine";




function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname || '/';

  // Handle domain-based routing on mount and route changes
  useEffect(() => {
    // Check if we need to redirect to a different domain
    const redirectUrl = shouldRedirectToDomain();
    if (redirectUrl) {
      window.location.href = redirectUrl;
      return;
    }

    // Auto-redirect root to home
    if (path === '/') {
      navigate('/home', { replace: true });
    }
  }, [path, navigate]);

  // More powerful, keyword-optimized, route-specific SEO
  let seoProps = { pathname: path };

  if (path.includes('deluxe')) {
    seoProps = {
      ...seoProps,
      title: 'Deluxe Accommodation – Mawathage Services Sri Lanka',
      description: 'Enjoy comfortable accommodation and warm Sri Lankan hospitality with Mawathage Services in Moragalla, Beruwala.',
      keywords: 'Sri Lanka accommodation, Moragalla rooms, Beruwala accommodation, Mawathage Services rooms',
      url: 'https://www.mawatage-services.com/rooms/deluxe',
    };
  } else if (path.includes('ayurveda')) {
    seoProps = {
      ...seoProps,
      title: 'Traditional Medicine in Sri Lanka – Mawathage Services',
      description: 'Explore Sri Lankan traditional medicine rooted in local herbs, Sinhala Buddhist practice, and holistic care for body, mind, and spirit.',
      keywords: 'Sri Lankan traditional medicine, Sinhala traditional healing, herbal treatments Sri Lanka, traditional medicine Beruwala',
      url: 'https://www.mawatage-services.com/ayurveda',
    };
  } else if (path.includes('yoga')) {
    seoProps = {
      ...seoProps,
      title: 'Wellness and Traditional Care – Mawathage Services',
      description: 'Discover traditional Sri Lankan wellness and holistic care with Mawathage Services in Beruwala.',
      keywords: 'Sri Lankan wellness, traditional care Beruwala, holistic wellness Sri Lanka',
      url: 'https://www.mawatage-services.com/yoga',
    };
  } else if (path.includes('rooms')) {
    seoProps = {
      ...seoProps,
      title: 'Accommodation – Mawathage Services Sri Lanka',
      description: 'Find comfortable rooms and welcoming stays at Mawathage Services in Moragalla, Beruwala, Sri Lanka.',
      keywords: 'Mawathage Services accommodation, Moragalla rooms, Beruwala stays, Sri Lanka accommodation',
      url: 'https://www.mawatage-services.com/rooms',
    };
  } else if (path.includes('about')) {
    seoProps = {
      ...seoProps,
      title: 'About Us – Mawathage Services Sri Lanka',
      description: 'Learn about Mawathage Services, your trusted local connection for accommodation, tours, traditional medicine, and vehicle rental in Sri Lanka.',
      keywords: 'about Mawathage Services, Sri Lanka local services, Sri Lanka accommodation tours, traditional medicine Beruwala',
      url: 'https://www.mawatage-services.com/about-us',
    };
  } else if (path.includes('contact')) {
    seoProps = {
      ...seoProps,
      title: 'Contact Us – Mawathage Services Sri Lanka',
      description: 'Contact Mawathage Services for accommodation, tours, traditional medicine, vehicle rental, and local assistance in Moragalla, Beruwala.',
      keywords: 'contact Mawathage Services, contact Moragalla, Beruwala travel services, Sri Lanka local assistance',
      url: 'https://www.mawatage-services.com/contact-us',
    };
  } else {
    seoProps = {
      ...seoProps,
      title: 'Mawathage Services – Discover Sri Lanka',
      description: 'Explore Sri Lanka with Mawathage Services: accommodation, traditional medicine, tours, vehicle rental, and trusted local hospitality in Moragalla, Beruwala.',
      keywords: 'Mawathage Services, Sri Lanka travel, Moragalla Beruwala, Sri Lanka accommodation tours, traditional medicine, vehicle rental',
      url: 'https://www.mawatage-services.com',
    };
  }

  return (
    <div>
      <SEO {...seoProps} />

      <Navbar />
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/tours" element={<Tours />} />
        <Route path="/vehicle-rental" element={<VehicleRental />} />
        <Route path="/rooms" element={<Accommodation />} />
        <Route path="/ayurveda" element={<TraditionalMedicine />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
